// extracted by mini-css-extract-plugin
module.exports = {"SearchIcon":"AutoSuggestInput_SearchIcon__oO1ZB","ValueContainer":"AutoSuggestInput_ValueContainer__dHfyX"};